/*
 * Author: Dw
 * File Created: Friday, 25-05-09 04:51 pm
 * Last Modified: Thursday, 25-05-15 09:58 am, by Ben Zhao
 */

import Image from 'next/image';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';
import { Box, Typography } from '@mui/material';
import { Flex } from '@ucard/ds/containers';
import { Icon } from '@ucard/ds/Icon';
import SectionBox from '../../../../../components/LandingContainer/SectionBox';
import { staticImgPrefix } from '../../../../../utils/prefix';
const DownLoadApp = () => {
  const {
    t
  } = useTranslation('home');
  return <SectionBox id="download-app" layerSx={{
    background: '#1A1A1A',
    position: 'relative',
    py: ['40px', '30px', '0']
  }} sx={{
    display: 'flex',
    flexDirection: ['column', 'row'],
    gap: '40px',
    alignItems: 'center',
    justifyContent: 'space-between'
  }} data-sentry-element="SectionBox" data-sentry-component="DownLoadApp" data-sentry-source-file="index.tsx">
      <Flex flexDirection="column" gap={[1.5, 2]} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Box fontSize={[24, 40]} fontWeight={600} lineHeight={['120%', '48px']} maxWidth={[600]} sx={{
        textAlign: ['center', 'left']
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Trans components={{
          1: <Box color="#7E61F3" component="div" />
        }} i18nKey="download-app.title" ns="home" data-sentry-element="Trans" data-sentry-source-file="index.tsx" />
        </Box>
        <Typography color="#848E9C" fontSize={[16, 18]} lineHeight={['24px', '26px']} textAlign={['center', 'left']} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {t('download-app.desc')}
        </Typography>
        <Flex alignItems="center" gap="15px" justifyContent={['center', 'flex-start']} mt={2} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Link href="https://apps.apple.com/sg/app/dcs-decard/id6743930389" target="_blank" data-sentry-element="Link" data-sentry-source-file="index.tsx">
            <Icon name="DownloadIOSBadge" sx={{
            fontSize: 121,
            height: 40
          }} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          </Link>
          <Link href="https://play.google.com/store/apps/details?id=com.dcs.decard.android&pcampaignid=web_share" target="_blank" data-sentry-element="Link" data-sentry-source-file="index.tsx">
            <Icon name="DownloadAndroidBadge" sx={{
            fontSize: 136,
            height: 40
          }} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          </Link>
        </Flex>
      </Flex>
      <Flex justifyContent={['center', 'flex-end']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Image alt="download" height={516} src={staticImgPrefix('/home/download.webp')} style={{
        height: 'auto',
        width: '100%',
        maxWidth: '480px'
      }} width={480} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </Flex>
    </SectionBox>;
};
export default DownLoadApp;